export const formatters = {
  formatValue(num) {
    if (num >= 1000000000) {
      return '$' + (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
    }
    if (num >= 1000000) {
      return '$' + (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
      return '$' + (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return '$' + num;
  },
  taskIcon(taskType) {
    switch (taskType) {
      case 1:
        return 'mdi-email';
      case 2:
        return 'mdi-calendar';
      case 3:
        return 'mdi-email';
      default:
        return 'mdi-notebook';
    }
  },
  taskColor(taskStatus) {
    switch (taskStatus) {
      case 0:
        return 'grey lighten-2';

      case 1:
        return 'teal lighten-2';
    }
  },

  oppStageColor(stage) {
    switch (stage) {
      case 1:
        return 'label-qualify';

      case 2:
        return 'label-pitch';

      case 3:
        return 'label-negotiate';

      case 4:
        return 'label-close';
    }
  },
  addImportantToInlineStyles(content) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const elements = doc.querySelectorAll('*');

    // Iterate over each element and apply important to inline styles
    elements.forEach((element) => {
      const styles = element.style;
      for (let i = 0; i < styles.length; i++) {
        const property = styles[i];
        const value = styles.getPropertyValue(property);
        styles.setProperty(property, value, 'important');
      }
    });

    return doc.body.innerHTML;
  },
};
